const STORAGE_KEY = "riata";
export const secureSet = async (value) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
};

export const secureGet = async () => {
  let raw = localStorage.getItem(STORAGE_KEY) || false;
  return raw === false ? raw : JSON.parse(raw);
};
